<template>
  <v-autocomplete
    :value="value"
    @change="input => $emit('input', input)"
    :outlined="typeof $attrs.filled === 'undefined'"
    v-bind="$attrs"
    :items="items"
    item-value="id"
    item-text="text"
    no-data-text="Nenhum pixel cadastrado"
    return-object
    clearable
    hide-details
  >
    <template v-slot:item="{ item }">
      <div class="d-flex align-center mr-3">
        <img v-if="item.type === 'Google Analytics'" src="/img/ga.svg" style="width: 20px;" alt="Google Analytics">
        <img v-if="item.type === 'Facebook Pixel'" src="/img/fb.svg" style="width: 20px;" alt="Facebook Pixel">
        <img v-if="item.type === 'Google Tag Manager'" src="/img/gtm.svg" style="width: 20px;" alt="Google Tag Manager">
      </div>
      <div class="pt-1 pb-1 d-flex flex-column">
        <span class="caption grey--text">{{item.type}}</span>
        <span class="caption font-weight-medium">{{item.name}}</span>
      </div>
    </template>
    <template v-slot:selection="{ item, index }" v-if="typeof $attrs.multiple !== 'undefined'">
      <v-chip v-if="index === 0" class="d-flex align-center">
        <div class="mr-2 d-flex align-center">
          <img v-if="item.type === 'Google Analytics'" src="/img/ga.svg" style="width: 20px;" alt="Google Analytics">
          <img v-if="item.type === 'Facebook Pixel'" src="/img/fb.svg" style="width: 20px;" alt="Facebook Pixel">
          <img v-if="item.type === 'Google Tag Manager'" src="/img/gtm.svg" style="width: 20px;" alt="Google Tag Manager">
        </div>
        <span>{{ item.name }}</span>
      </v-chip>
      <span v-if="index === 1" class="grey--text text-caption">
        +{{ value.length - 1 }} outro(s)
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['value'],
  computed: {
    ...mapState({
      data: state => state.pixels.data
    }),
    items () {
      return this.data.map(item => {
        return {
          ...item,
          text: `${item.type} - ${item.name}`
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>